import React from 'react';
import { Calendar, User, ArrowRight, Clock } from 'lucide-react';
import { Button } from './ui/button';

const blogs = [
  {
    id: 1,
    slug: 'how-to-choose-best-home-theatre-company-bangalore',
    title: 'How to Choose the Best Home Theatre Company in Bangalore: A Complete Guide',
    excerpt: 'Discover the key factors to consider when selecting a home theatre installation company in Bangalore. From acoustic expertise to after-sales support, learn what separates the best from the rest.',
    author: 'Pro Cinemax Team',
    date: 'March 1, 2026',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80',
    category: 'Guide'
  },
  {
    id: 2,
    slug: 'top-home-automation-trends-2026-bangalore',
    title: 'Top Home Automation & Theatre Trends in Bangalore for 2026',
    excerpt: 'Explore the latest trends in home automation and private cinema experiences. From Dolby Atmos to smart lighting integration, see what\'s transforming Bangalore homes.',
    author: 'Pro Cinemax Team',
    date: 'February 28, 2026',
    readTime: '6 min read',
    image: 'https://images.unsplash.com/photo-1593784991095-a205069470b6?w=800&q=80',
    category: 'Trends'
  }
];

const Blog = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gray-900 py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Our Blog
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Insights, guides, and trends in home theatre and automation
          </p>
        </div>
      </header>

      {/* Blog Grid */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {blogs.map((blog) => (
              <article
                key={blog.id}
                className="bg-white rounded-2xl overflow-hidden border-2 border-cyan-700/30 hover:border-cyan-700 hover:shadow-xl transition-all duration-300 group"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="bg-cyan-800 text-white text-xs font-semibold px-3 py-1 rounded-full">
                      {blog.category}
                    </span>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {blog.date}
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      {blog.readTime}
                    </div>
                  </div>
                  
                  <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-cyan-800 transition-colors">
                    {blog.title}
                  </h2>
                  
                  <p className="text-gray-600 mb-4 line-clamp-3">
                    {blog.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <User className="w-4 h-4 text-gray-400" />
                      <span className="text-sm text-gray-500">{blog.author}</span>
                    </div>
                    <Button
                      variant="ghost"
                      className="text-cyan-800 hover:text-cyan-900 p-0 h-auto font-semibold group/btn"
                      onClick={() => window.location.href = `/blog/${blog.slug}`}
                    >
                      Read More
                      <ArrowRight className="ml-1 w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                    </Button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Back to Home */}
      <section className="pb-16">
        <div className="container mx-auto px-6 text-center">
          <Button
            onClick={() => window.location.href = '/'}
            className="bg-cyan-800 hover:bg-cyan-900 text-white px-8 py-3 rounded-full"
          >
            Back to Home
          </Button>
        </div>
      </section>
    </div>
  );
};

export default Blog;
